import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownOutlined, SafetyCertificateOutlined, UpOutlined } from '@ant-design/icons';
import { SectionIcon } from '../SectionIcon';

export const EquipmentChips = ({ equipment, onToggleAll }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section id="equipment" className="card side-card" aria-labelledby="equipment-title">
            <h2 id="equipment-title" className="h2">
                <SectionIcon icon={SafetyCertificateOutlined} />
                {t('layout.equipment')}
            </h2>
            <ul className="chips">
                {equipment.chips.map((chip, i) => (
                    <li className={`eq-chip${chip.hidden ? ' more' : ''}`} key={`${chip.code}-${chip.desc}-${i}`}>
                        {chip.code && <span className="mono eq-code">{chip.code}</span>}
                        {chip.desc}
                    </li>
                ))}
            </ul>
            {equipment.more > 0 && (
                <button type="button" className="textlink chips-more noprint" onClick={onToggleAll}>
                    {equipment.expanded ? <UpOutlined /> : <DownOutlined />}{' '}
                    {equipment.expanded ? t('layout.showLess') : t('layout.showMore', { count: equipment.more })}
                </button>
            )}
        </section>
    );
};
